import React from "react";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
// import Box from '@material-ui/core/Box';
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
// import AppBar from "../../header/index"
// import SignInButton from "../../button/globleButtons";
// import AppProvider from "../../bootstrap/index"
import Button from "@material-ui/core/Button";
import { withStyles } from "@material-ui/core/styles";
// import Button from '@material-ui/core/Button';
import { blueGrey } from "@material-ui/core/colors";
// import CancleReason from './cancleReason'
// import { makeStyles } from '@material-ui/core/styles';
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
// import Appointmentrequest from './AppointmentRequest'
const useStyles = makeStyles((theme) => ({
  "@global": {
    body: {
      backgroundColor: theme.palette.common.white,
    },
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    // marginTop: theme.spacing(1),
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  avatar: {
    margin: 10,
    width: 300,
    height: 60,
    // margin: theme.spacing(1),
    backgroundColor: "white",
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    // marginTop: theme.spacing(1),
  },
  button: {
    width: "100%",
    // borderColor: '#00AC75',
    color: "#00AC75",
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  TextField: {
    marginTop: "10%",
    width: "100%",
    backgroundColor: "#ffffff",
  },
  coverBackgroundContainer: {
    backgroundColor: "#F7F8F9",
    // height: "100vh",
    // backgroundSize: "cover",
    display: "flex",
    // flexDirection: "column",
    // justifyContent: "center",
    alignItems: "center",
    // paddingLeft:"4%",
    // paddingRight:"4%",
    // paddingTop:"90px",
    // paddingBottom:"20px",
  },
}));

const ColorButton = withStyles((theme) => ({
  root: {
    color: theme.palette.getContrastText(blueGrey[500]),
    backgroundColor: blueGrey[500],
    "&:hover": {
      backgroundColor: blueGrey[700],
    },
  },
}))(Button);

const CancleAppointmentrequest = (props) => {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <div className={classes.coverBackgroundContainer}>
      {/* <Box display="flex" justifyContent="flex-start" m={1} p={1} fullWidth  >
          <Box p={2} >
        <Typography component="h6" variant="h6" style={{marginTop:"50px",marginBottom:"1%"}}>
          Appointment Request
        </Typography>
        </Box>
        </Box>
     <AppProvider >
    <AppBar/> */}
      {/* <Container component="main" maxWidth="xs" style={{background:"#ffffff",marginTop:"1%"}}> 
        
        <Box display="flex" justifyContent="flex-start" m={1} p={1} onClick={expand} >
        <Box p={2}  >
         <Grid container
                     style={
                             {
                                paddingLeft: "8%",
                                paddingRight: "8%",
                                marginTop:"13%"
                            }
                             }>
                            
                      <Grid item xs={12} sm={12}>
                           <Typography color="textSecondary"
                              className={
                                 classes.subText1
                           }>
                             <b>
                             Attendes (18)
                            </b>
                           </Typography>
                      </Grid>
         </Grid>
        </Box>
               <Grid item xs={3}></Grid>
               <Box p={1} >
                      <Grid item xs={12} sm={12}>
                         <Typography color="textSecondary"
                              className={
                                 classes.subText1
                         }>
                            Date & Time
                            
                         <Typography color="textPrimary">
                              24-05-2020 09:30 PM
                         </Typography>
                            
                         </Typography>
                      </Grid>
               
               </Box>
        </Box>
               
    </Container> */}

      <Container
        component="main"
        maxWidth="xs"
        style={{
          width: "100%",
          marginTop: "10%",
          background: "white",
          padingBottom: "5%",
        }}
      >
        {/* <div className={classes.paper} > */}
        {/* <Box display="flex" justifyContent="flex-start" m={1} p={1} fullWidth  >
    <Box p={2} > */}

        <Grid
          container
          style={{
            paddingLeft: "8%",
            paddingRight: "8%",
            marginTop: "5%",
          }}
        >
          <Grid item xs={12} sm={12}>
            <Typography color="textSecondary" className={classes.subText1}>
              Attendes
            </Typography>
            <TextField
              className={classes.TextField}
              // autoFocus
              id="standard-read-only-input"
              disabled
              multiline
              defaultValue="Mario Speedwagon, Petey Cruiser,Anna Sthesia,Paul Molive,Anna Mull,
                                            Gail Forcewind,Paige Turner,Bob Frapples"
              InputProps={{
                readOnly: true,
              }}
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <div style={{ marginTop: "8%" }}>
              <Typography color="textSecondary" className={classes.subText1}>
                Request Message
              </Typography>

              <TextField
                className={classes.TextField}
                // autoFocus
                id="standard-read-only-input"
                disabled
                multiline
                defaultValue="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed cursus habitant
                            tincidunt id non feugiat."
                InputProps={{
                  readOnly: true,
                }}
                fullWidth
              />
            </div>
          </Grid>
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <div style={{ marginTop: "8%" }}>
                <Typography color="textSecondary" className={classes.subText1}>
                  Duration
                </Typography>
                <TextField
                  className={classes.TextField}
                  // autoFocus
                  id="standard-read-only-input"
                  disabled
                  multiline
                  defaultValue="30Min"
                  InputProps={{
                    readOnly: true,
                  }}
                  fullWidth
                />
              </div>
            </Grid>
            <Grid item xs={6}>
              <div style={{ marginTop: "8%" }}>
                <Typography color="textSecondary" className={classes.subText1}>
                  Date & Time
                </Typography>
                <TextField
                  className={classes.TextField1}
                  // autoFocus
                  id="standard-read-only-input"
                  disabled
                  multiline
                  defaultValue="24-05-2017 10:30 AM.       "
                  InputProps={{
                    readOnly: true,
                  }}
                  fullWidth
                />
              </div>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <div style={{ marginTop: "8%" }}>
              <Typography color="textSecondary">Billing Details</Typography>
            </div>
          </Grid>
          <Grid container spacing={3}>
            <Grid item xs={10}>
              <Typography variant="subtitle1">Cost</Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography
                variant="subtitle1"
                style={{ float: "right", boxShadow: "none" }}
              >
                $7867
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            <Grid item xs={10}>
              <Typography variant="subtitle1">Internet Processing</Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography
                variant="subtitle1"
                style={{ float: "right", boxShadow: "none" }}
              >
                $20
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            <Grid item xs={10}>
              <Typography variant="subtitle1">GST</Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography
                variant="subtitle1"
                style={{ float: "right", boxShadow: "none" }}
              >
                $10
              </Typography>
            </Grid>
          </Grid>

          <div style={{ marginTop: "8%", width: "100%" }}>
            <ColorButton
              variant="contained"
              color="#4F5D75"
              style={{ marginBottom: "5%", width: "100%" }}
              onClick={handleOpen}
            >
              {" "}
              Reject Appointment{" "}
            </ColorButton>

            <Modal
              aria-labelledby="transition-modal-title"
              aria-describedby="transition-modal-description"
              className={classes.modal}
              open={open}
              onClose={handleClose}
              closeAfterTransition
              BackdropComponent={Backdrop}
              BackdropProps={{
                timeout: 500,
              }}
            >
              <Fade in={open}>
                <div className={classes.paper}>
                  <Container
                    component="main"
                    maxWidth="xs"
                    style={{ background: "#ffffff" }}
                  >
                    <form className={classes.form}>
                      <Typography
                        component="h6"
                        variant="h6"
                        style={{ paddingTop: "7%" }}
                      >
                        Reason to Cancle
                      </Typography>

                      <TextField
                        className={classes.TextField}
                        autoFocus
                        id="reason to Cancle"
                        name="reason to Cancle"
                        required
                        disabled
                        defaultValue="DSGH Vghj datsf kuser  vffgsvv hisd bvghhf dsvdu vuiid cdafvsu bjnmn dssg hbnbn scddh vjhjhj csftfyy"
                        multiline
                        autoComplete="reason to Cancle"
                        variant="standard"
                        fullWidth
                      />
                      <div style={{ marginTop: "10%", width: "100%" }}>
                        <ColorButton
                          variant="contained"
                          color="primary"
                          fullWidth
                        >
                          {" "}
                          Reject{" "}
                        </ColorButton>
                      </div>
                    </form>
                    {/* </div> */}
                  </Container>
                </div>
              </Fade>
            </Modal>
          </div>
        </Grid>
        {/* </Box>
      </Box> */}
      </Container>
      {/* </AppProvider> */}
    </div>
  );
};
export default CancleAppointmentrequest;
